export const TITLE = 'Allowed attempts';
export const PLACEHOLDER = '1';
export const CAPTION = 'Leaving this blank or 0 would mean that the student can have an infinite number of attempts.';
export const START_ENHANCER = '#';
